
    import {Component, Inject, Vue} from "vue-property-decorator";
    import Api, { ApiRepository } from '@/api';
    import InputText from '@/components/form/Input-text.vue';
    import Layout from '@/components/layout/Layout.vue';
    import InputSelect from '@/components/form/Input-select.vue';
    import {Validator} from 'vee-validate';

    @Component({
        components: {
            InputText,
            InputSelect,
            Layout,
        },
    })

    export default class UserEdit extends Vue {
        private roles: Array<Object> = [];
        private partnersMap: Array<Object> = [];

        private user: any = {
            partner: {}
        };
        private originalEmail: string = '';
        private newUser = false;

        public async mounted() {
            this.roles = [
                {
                    name: 'Partner',
                    value: 'partner',
                },
                {
                    name: 'Administrátor',
                    value: 'admin',
                }
            ];

            let response = await ApiRepository.getPartners();
            response.data.forEach((partner: any) => {
                this.partnersMap.push({
                    name: partner.name,
                    value: partner.id,
                });
            });

            const userId = this.$route.params.user;
            if (userId) {
                const params = {
                    relations: ['partner'],
                };

                this.user = await ApiRepository.getUser(userId, params);
                if (this.user.partner == null) {
                    this.user.partner = {};
                }
                this.originalEmail = this.user.email;
            } else {
                this.newUser = true;
                this.originalEmail = 'Nový uživaťeľ';
            }
        }

        private async onSubmit(event: any) {
            event.preventDefault();
            this.$validator.validate().then((valid) => {
                if (valid && this.selectsValid()) {
                    if (this.newUser) {
                        ApiRepository.createUser({
                            email: this.user.email,
                            role: this.user.role,
                            partner: this.user.partner.id,
                        });
                    } else {
                        ApiRepository.editUser(this.user.id, {
                            email: this.user.email,
                            role: this.user.role,
                            partner: this.user.partner.id,
                        });
                    }
                } else {
                    this.$notify({group: 'auth', type: 'error', text: 'Užívateľ typu Partner musí mať nastaveného partnera'});
                }
            });
        }

        private selectsValid() {
            return (this.user.role && ((this.user.role == 'partner' && this.user.partner.id) || this.user.role == 'admin'));
        }
    }
